__turbopack_context__.v({
  "containerLeft": "modals-module-scss-module__uL3yXa__containerLeft",
  "doctorImage": "modals-module-scss-module__uL3yXa__doctorImage",
  "doctorModal": "modals-module-scss-module__uL3yXa__doctorModal",
  "greifswald": "modals-module-scss-module__uL3yXa__greifswald",
  "hamburg": "modals-module-scss-module__uL3yXa__hamburg",
  "headerTextContainer": "modals-module-scss-module__uL3yXa__headerTextContainer",
  "imageGridContainer": "modals-module-scss-module__uL3yXa__imageGridContainer",
  "maskedOverflow": "modals-module-scss-module__uL3yXa__maskedOverflow",
  "newsletterContainerLeft": "modals-module-scss-module__uL3yXa__newsletterContainerLeft",
  "newsletterHeaderTextContainer": "modals-module-scss-module__uL3yXa__newsletterHeaderTextContainer",
  "newsletterModal": "modals-module-scss-module__uL3yXa__newsletterModal",
  "studyCentersContainer": "modals-module-scss-module__uL3yXa__studyCentersContainer",
  "studyModal": "modals-module-scss-module__uL3yXa__studyModal",
  "studyModalOuter": "modals-module-scss-module__uL3yXa__studyModalOuter",
});
